import React, { Component } from 'react';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import ListGroup from 'react-bootstrap/ListGroup';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import logo from '../../../assets/softie.PNG';
import softieImg from '../../../assets/softie.PNG';

var firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');

export class QA extends Component {
  constructor(props) {
    super(props);

    this.openQAModal = this.openQAModal.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getReplies = this.getReplies.bind(this);
    this.handleSoftieClick = this.handleSoftieClick.bind(this);
    this.handleReplySoftie = this.handleReplySoftie.bind(this);
    this.getReplyButton = this.getReplyButton.bind(this);
    this.handleReplyUpload = this.handleReplyUpload.bind(this);

    this.db = firebase.firestore();
    this.ref = this.db
      .collection('software_pages')
      .doc(this.props.prodId)
      .collection('qas');

    this.state = {
      showModal: false,
      replyText: '',
      qaId: this.props.qaData.qaId,
      softies: this.props.qaData.softies,
      userLikes: this.props.qaData.userLikes,
      qaAnswered: this.props.qaData.qaAnswered,
      replies: [],
      replySofties: {},
      softieGiven: this.props.qaData.userLikes.includes(this.props.userEmail),
      softieButtonDisabled: false,
      devAccount: this.props.devAccount,
    };
  }

  componentDidMount() {
    let _replies = [],
      _replySofties = {};
    let _this = this;
    this.ref
      .doc(this.state.qaId)
      .collection('replies')
      .get()
      .then(query => {
        query.forEach(doc => {
          _replies = _replies.concat(doc.data());
          _replySofties[doc.data().replyId] = doc.data().softies;
        });
        // Always udpate state in THEN after the data has been loaded
        _this.setState({ replies: _replies, replySofties: _replySofties });
      });
  }

  handleSoftieClick() {
    let qaRef = this.ref.doc(this.state.qaId);
    this.setState({
      softieGiven: !this.state.softieGiven,
      softieButtonDisabled: true,
    });

    return this.db
      .runTransaction(transaction => {
        // This code may get re-run multiple times if there are conflicts.
        return transaction.get(qaRef).then(doc => {
          if (!doc.exists) {
            console.log('Document does not exist!');
          } else {
            var newSofties = this.state.softieGiven
              ? doc.data().softies + 1
              : doc.data().softies - 1;
            var newUserLikes = this.state.softieGiven
              ? doc.data().userLikes.concat(this.props.userEmail)
              : doc
                  .data()
                  .userLikes.filter(uId => uId !== this.props.userEmail);
            this.setState({ softies: newSofties, softieButtonDisabled: false }); // Update the state as well
            transaction.update(qaRef, {
              softies: newSofties,
              userLikes: newUserLikes,
            });
          }
        });
      })
      .then(() => {
        console.log('Transaction successfully committed!');
      })
      .catch(error => {
        console.log('Transaction failed: ', error);
      });
  }

  handleReplySoftie(replyId) {
    let replyRef = this.ref
      .doc(this.state.qaId)
      .collection('replies')
      .doc(replyId);

    return this.db
      .runTransaction(transaction => {
        // This code may get re-run multiple times if there are conflicts.
        return transaction.get(replyRef).then(doc => {
          if (!doc.exists) {
            console.log('Document does not exist!');
          } else {
            const softieGiven = doc
              .data()
              .userLikes.includes(this.props.userEmail);
            console.log(
              'Softie Given: ' +
                softieGiven +
                'Old softies: ' +
                doc.data().softies
            );
            var newSofties = !softieGiven
              ? doc.data().softies + 1
              : doc.data().softies - 1;
            var newUserLikes = !softieGiven
              ? doc.data().userLikes.concat(this.props.userEmail)
              : doc
                  .data()
                  .userLikes.filter(uId => uId !== this.props.userEmail);
            var newReplySofties = this.state.replySofties;
            newReplySofties[replyId] = newSofties;
            this.setState({ replySofties: newReplySofties }); // Update the state as well
            transaction.update(replyRef, {
              softies: newSofties,
              userLikes: newUserLikes,
            });
          }
        });
      })
      .then(() => {
        console.log('Transaction successfully committed!');
      })
      .catch(error => {
        console.log('Transaction failed: ', error);
      });
  }

  getReplyName(replyCreator, devReply) {
    return devReply ? (
      <Card.Subtitle>
        {' '}
        {replyCreator} <Badge variant="secondary"> Dev Reply </Badge> replied{' '}
      </Card.Subtitle>
    ) : (
      <Card.Subtitle> {replyCreator} replied </Card.Subtitle>
    );
  }

  getReplies() {
    if (this.state.replies === undefined) return <div></div>;
    if (this.state.replies[0] === undefined) return <div></div>;
    return this.state.replies.map(reply => (
      <ListGroup.Item as="li">
        <div>
          {this.getReplyName(reply.replyCreator, reply.devReply)}
          <Card.Body style={headerMain}>
            {reply.replyText}
            <div style={alignTopRight}>
              <div>
                <b style={{ fontSize: '1.7em' }}>
                  {' '}
                  {this.state.replySofties[reply.replyId]}
                  <input
                    type="image"
                    id="image"
                    alt="Give Softie"
                    width="30"
                    height="42px"
                    disabled={false}
                    style={softieStyle}
                    className={
                      reply.userLikes.includes(this.props.userEmail)
                        ? 'softieGiven'
                        : 'softieNotGiven'
                    }
                    src={softieImg}
                    onClick={this.handleReplySoftie.bind(this, reply.replyId)}
                  />
                </b>
              </div>
            </div>
          </Card.Body>
        </div>
      </ListGroup.Item>
    ));
  }

  handleReplyUpload() {
    this.ref
      .doc(this.state.qaId)
      .update({
        qaAnswered: true
      })
      .then(() => {
        console.log('Reply!');
        this.setState({
          replies: this.state.replies.concat(
            this.props.submitReply(
              this.state.qaId,
              this.state.replyText,
              this.state.devAccount
            )
          ),
          openQAModal: false,
        });
      })
      .catch(err => console.log('Error updating document', err));
  }

  openQAModal() {
    this.setState({
      showModal: true,
    });
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
      showAlert: false,
    });
  }

  getReplyButton() {
    if(!this.props.loggedIn) return (<div> </div>)
    return (
      <InputGroup className="mb-3">
        <FormControl
          name="replyText"
          onChange={this.handleChange}
          placeholder="Know the answer? Submit one!"
          aria-label="Search"
          maxLength="170"
          aria-describedby="basic-addon2"
          width="100%"
        />
        <InputGroup.Append>
          <Button variant="secondary" onClick={this.handleReplyUpload}>
            Submit
          </Button>
        </InputGroup.Append>
      </InputGroup>
    )
  }

  render() {
    let softieClass = this.state.softieGiven ? 'softieGiven' : 'softieNotGiven';

    return (
      <div>
        <div>
          <Card
            border={this.state.qaAnswered ? 'success' : 'warning'}
            body
            style={{ margin: '0px 8px 0px 8px' }}
          >
            <Card.Subtitle>
              {' '}
              {this.props.qaData.qaCreator} posted{' '}
            </Card.Subtitle>
            <Card.Body style={headerMain}>
              {this.props.qaData.qaText}
              <div style={alignTopRight}>
                <i
                  className="fas fa-angle-double-right"
                  style={symbolStyle}
                  onClick={this.openQAModal}
                ></i>
              </div>
            </Card.Body>
            <div>
              <b style={{ fontSize: '1.7em' }}>
                {' '}
                {this.state.softies}{' '}
                <input
                  type="image"
                  id="image"
                  alt="Give Softie"
                  width="30"
                  height="42px"
                  disabled={this.state.softieButtonDisabled}
                  style={softieStyle}
                  className={softieClass}
                  src={softieImg}
                  onClick={this.handleSoftieClick}
                />
              </b>
            </div>
          </Card>

          <Modal
            size="lg"
            centered
            show={this.state.showModal}
            onHide={() => this.setState({ showModal: false })}
          >
            <Modal.Header closeButton style={headerMain}>
              <Modal.Title>Q. {this.props.qaData.qaText}</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <ListGroup as="ul">
                <this.getReplies />
              </ListGroup>
            </Modal.Body>

            <Modal.Footer>
              <this.getReplyButton />
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

const headerMain = {
  position: 'relative',
};

const alignTopRight = {
  position: 'absolute',
  top: '50%',
  right: '0.5%',
  msTransform: 'translate(-0.5%, -50%)',
  transform: 'translate(-0.5%, -50%)',
};

const softieRight = {
  position: 'absolute',
  top: '3px',
  right: '12px',
};

const symbolStyle = {
  fontSize: '1.75em',
  color: 'gray',
};

const softieTopRightStyle = {
  position: 'absolute',
  top: '50%',
  right: '0.5%',
  msTransform: 'translate(-0.5%, -50%)',
  transform: 'translate(-0.5%, -50%)',
  padding: '6px',
  margin: '8px 0px',
  outline: 'none',
};

const softieStyle = {
  verticalAlign: 'middle',
  padding: '2px',
};

export default QA;
